module.exports = __webpack_public_path__ + "img/MatPL-3.d07b5ff8.png";